export default __webpack_public_path__ + "static/media/cancelight-diary.be2851a8.png";